export default __webpack_public_path__ + "img/fgytliFo.32f6ceb4.svg";